import { render, staticRenderFns } from "./b-popup-test.vue?vue&type=template&id=41798fa9&scoped=true"
import script from "./b-popup-test.vue?vue&type=script&lang=js"
export * from "./b-popup-test.vue?vue&type=script&lang=js"
import style0 from "./b-popup-test.vue?vue&type=style&index=0&id=41798fa9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41798fa9",
  null
  
)

export default component.exports